"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const react_1 = __importStar(require("react"));
const Icon_1 = require("../Icon");
const Link_styles_1 = require("./Link.styles");
const isExternalLink = (props) => "href" in props && !!props.href;
const isInternalLink = (props) => "to" in props && !!props.to;
const Link = (0, react_1.forwardRef)((props, forwardedRef) => {
    const { children } = props, propsWithoutChildren = __rest(props, ["children"]);
    if (isExternalLink(props) && isInternalLink(props)) {
        console.warn('Link component should not have both "href" and "to" props');
    }
    const isOpenInNewTab = props.target === "_blank";
    const openWindowIcon = isOpenInNewTab && (react_1.default.createElement(Icon_1.Icon, { name: "OpenWindow", size: "small", color: "currentColor", "aria-label": "Opens in new tab" }));
    return isExternalLink(props) ? (react_1.default.createElement(Link_styles_1.StyledLink, Object.assign({ ref: forwardedRef, "$color": propsWithoutChildren.color }, propsWithoutChildren),
        children,
        openWindowIcon)) : (react_1.default.createElement(Link_styles_1.StyledRouterDomLink, Object.assign({ ref: forwardedRef, "$color": propsWithoutChildren.color }, propsWithoutChildren),
        children,
        openWindowIcon));
});
exports.Link = Link;
//# sourceMappingURL=Link.js.map